import { VFC } from 'react'
import { ResponsiveImageProps } from '@/components/types'

export const ResponsiveImage: VFC<ResponsiveImageProps> = ({ src, alt, query }) => {
  const lgImageSrc = (): string => {
    return src.replace(/_sm.(gif|jpe?g|png|svg)/, '_lg.$1')
  }

  const withQuery = (value: string): string => {
    if (!query) {
      return value
    }

    const normalizedQuery = query.startsWith('?') ? query.slice(1) : query
    const separator = value.includes('?') ? '&' : '?'
    return `${value}${separator}${normalizedQuery}`
  }

  return (
    <picture>
      <source srcSet={withQuery(lgImageSrc())} media="(min-width: 768px)" />
      <img src={withQuery(src)} alt={alt} />
    </picture>
  )
}
